// ----------------------------------------------------------------------
// <copyright file="Izenda.RefreshButton.jsx" company="Izenda"> Copyright (c)
// 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = require('react');
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = require('mobx-react').propTypes;
  var connect = require('share/enhancers/Izenda.Connect');

  var RefreshButton = connect()(function (props) {
    var dashboardPart = props.dashboardPart;
    var localization = props.localization;

    if (!dashboardPart.showRefeshButton) {
      return null;
    }
    var onClick = function () {
      props.onUpdateData();
    };

    return (
      <a className="btn u_noBorderAll" title={localization.getText('COPY_MANAGEMENT_LABEL_REFRESH')} onClick={onClick}>
        <i className="icon-refresh"/>
        { props.showLabel && <span>{localization.getText('COPY_MANAGEMENT_LABEL_REFRESH')}</span>}
      </a>
    );
  });

  RefreshButton.propTypes = {
    dashboardPart: ObservablePropTypes.observableObject.isRequired,
    onUpdateData: PropTypes.func
  };

  module.exports = RefreshButton;
}();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/Header/Izenda.RefreshButton.jsx